import axios from 'axios'
import store from '@/store'

async function insertContractsProjects(values) {
    try {
        /**
         * URL Original: /order/question
         */
        const result = await axios.post(`${process.env.VUE_APP_ROOT_API}/clients/v1/requestfinancing/contractsandprojects`, {
            ...values
        }, {
            headers: {
                Authorization: `Bearer ${store.state.user.token}`
            }
        })
        return result.data
    } catch(err) {
        return err
    }
}

export default insertContractsProjects